import * as mentorApi from '../../api/mentorApi';
import { entityKey } from '../ids';
import { titleCaseWord } from './helpers';

/**
 * Canonical cohort entity for workspace store.
 */
export function normalizeCohortEntity(cohort) {
  if (!cohort) return null;
  const base = mentorApi.normalizeCohortDetail(cohort) || mentorApi.normalizeCohort(cohort);
  if (!base) return null;

  return {
    ...base,
    id: entityKey(base.id),
    schoolId: entityKey(base.schoolId),
    branchId: base.branchId ? entityKey(base.branchId) : '',
    spocId: base.spocId ? entityKey(base.spocId) : '',
    studentIds: Array.isArray(base.studentIds) ? base.studentIds.map(String) : [],
    counselorIds: Array.isArray(base.counselorIds) ? base.counselorIds.map(String) : [],
    auditorAssignments: Array.isArray(base.auditorAssignments)
      ? base.auditorAssignments.map(a => ({
          ...a,
          auditorId: a.auditorId ? String(a.auditorId) : '',
        }))
      : [],
    status: titleCaseWord(base.status) || 'Active',
  };
}